module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門2_7.824c97f1.png";